import { Box, dimensions } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { useIncidenceOptionSections } from 'modules/payroll_bundle/hooks/useIncidenceOptionSections'
import { useInhousePayroll } from 'modules/payroll_bundle/hooks/useInhousePayroll'
import { usePayrollContextlessPolicies } from 'modules/payroll_bundle/hooks/usePayrollContextlessPolicies'

import Menu from './_Menu'
import { Settings } from './_Settings'

export const PayrollIncidencesSettings = observer(() => {
  const {
    company: { id: companyId, name: companyName },
  } = useCurrentSession()
  const { hasInhousePayroll } = useInhousePayroll()
  const hasProfessionals = hasFeature('factorial_professionals')
  const { loading, companyIncidenceSettings, incidenceOptionSections } = useIncidenceOptionSections(
    companyId,
    false
  )

  const { loading: loadingPayrollContextlessPolicies, canSeePayrollIncidencesSettings } =
    usePayrollContextlessPolicies()

  return (
    <ResponsivePage.Body
      authorized={canSeePayrollIncidencesSettings}
      showHeader={false}
      loading={loading || loadingPayrollContextlessPolicies}
      error={null}
      banner={
        !hasInhousePayroll && hasProfessionals
          ? {
              message: i18n.t('incidences.header.incidences_notice'),
              color: 'warning',
            }
          : undefined
      }
    >
      <Box flexDirection="row" justifyContent="spaceBetween" gap="s40" width="full">
        <Box style={{ position: 'sticky', top: dimensions.s64 }} width="s300" alignSelf="flexStart">
          <Menu incidenceOptionSections={incidenceOptionSections} />
        </Box>
        <Box paddingTop="s40" flexGrow>
          <Settings
            companyId={companyId}
            companyName={companyName}
            companyIncidenceSettings={companyIncidenceSettings}
            incidenceOptionSections={incidenceOptionSections}
          />
        </Box>
      </Box>
    </ResponsivePage.Body>
  )
})
